"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _paramsFormatter = require("../paramsFormatter");
var _default = {
  dryRunTransaction: {
    method: "dry_run_transaction",
    paramsFormatters: [_paramsFormatter.formatter.toRawTransaction]
  },
  // skip _compute_transaction_hash

  calculateDaoMaximumWithdraw: {
    method: "calculate_dao_maximum_withdraw",
    paramsFormatters: [_paramsFormatter.formatter.toOutPoint, _paramsFormatter.formatter.toHash]
  }

  // skip estimate_fee_rate

  // skip _compute_script_hash
};
exports.default = _default;
//# sourceMappingURL=experimental.js.map